import React, { useEffect, useState } from "react";
import {
  getNotifications,
  subscribeNotifications,
} from "./NotificationManager";

// NapflixOS Notification Manager v7
// Passive OS toast stack: no focus, no pointer capture, no modal behavior.
const levelStyles = {
  info: { accent: "rgba(120, 180, 255, 0.92)", label: "Info" },
  success: { accent: "rgba(120, 235, 170, 0.92)", label: "Ready" },
  warning: { accent: "rgba(255, 206, 92, 0.96)", label: "Warning" },
  error: { accent: "rgba(255, 105, 105, 0.96)", label: "Error" },
};

export default function NotificationOverlay() {
  const [notifications, setNotifications] = useState(getNotifications());

  useEffect(() => {
    setNotifications(getNotifications());
    return subscribeNotifications(setNotifications);
  }, []);

  if (notifications.length === 0) return null;

  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        top: 28,
        right: 28,
        zIndex: 2147483100,
        width: 320,
        display: "flex",
        flexDirection: "column",
        gap: 12,
        pointerEvents: "none",
        userSelect: "none",
      }}
    >
      <style>{`
        @keyframes napflixToastIn {
          from { opacity: 0; transform: translate3d(18px, -8px, 0); }
          to { opacity: 1; transform: translate3d(0, 0, 0); }
        }
      `}</style>

      {notifications.map((notification) => {
        const level =
          levelStyles[notification.level] || levelStyles.info;

        return (
          <div
            key={notification.id}
            style={{
              overflow: "hidden",
              borderRadius: 14,
              border: "1px solid rgba(255,255,255,0.18)",
              background: "rgba(8, 12, 22, 0.78)",
              boxShadow:
                "0 18px 44px rgba(0,0,0,0.42), inset 0 1px 0 rgba(255,255,255,0.12)",
              backdropFilter: "blur(16px) saturate(1.25)",
              color: "rgba(255,255,255,0.92)",
              animation: "napflixToastIn 240ms ease both",
            }}
          >
            <div
              style={{
                height: 3,
                background: level.accent,
                boxShadow: `0 0 18px ${level.accent}`,
              }}
            />
            <div style={{ padding: "14px 16px 15px" }}>
              <div
                style={{
                  fontFamily: "'Outfit', sans-serif",
                  fontSize: 10,
                  letterSpacing: 2,
                  textTransform: "uppercase",
                  color: level.accent,
                  marginBottom: 6,
                }}
              >
                {level.label}
              </div>
              {notification.title && (
                <div
                  style={{
                    fontFamily: "'Outfit', sans-serif",
                    fontSize: 15,
                    fontWeight: 700,
                    marginBottom: notification.message ? 5 : 0,
                  }}
                >
                  {notification.title}
                </div>
              )}
              {notification.message && (
                <div
                  style={{
                    fontFamily: "'Outfit', sans-serif",
                    fontSize: 13,
                    lineHeight: 1.35,
                    color: "rgba(255,255,255,0.68)",
                  }}
                >
                  {notification.message}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
